import { render, staticRenderFns } from "./TableDevolucion.vue?vue&type=template&id=689fc71a"
import script from "./TableDevolucion.vue?vue&type=script&lang=js"
export * from "./TableDevolucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports